import { useContext, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import config from "../../../config";
import "./error.css";

function Error(){
    const serviceCtx = useContext(ServiceContext);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchHealthCheck = async () => {
            if (!serviceCtx) return;
          
            try {
                await Promise.all([
                    serviceCtx.infrastructureHealthCheckService.get("HealthCheck"),
                    serviceCtx.notificationHealthCheckService.get("HealthCheck"),
                    serviceCtx.dataHealthCheckService.get("HealthCheck"),
                    serviceCtx.authenticationService.get("HealthCheck"),
                ]);
                navigate("/");
            } catch (error) {
                console.error("Error fetching health check:", error);
            } 
        };
    
        fetchHealthCheck();
        const intervalId = setInterval(fetchHealthCheck, config.uiSettings.refreshTimeOfRequest);
        return () => clearInterval(intervalId);
    }, [serviceCtx, navigate]);

    return (
    <div className="error-card">
        <div className="error-card-content">
            <div className="error-card-content-medium">Scheduled maintenance in progress...</div>
            <div className="error-card-content-small">We'll be back shortly. We apologize for the inconvenience.</div>
        </div>
    </div>
  )
}

export default Error;